import gql from 'graphql-tag'

export const QUERY_LIST_LOGS = gql`
  query OperationLogs($fieldFilters: [FieldFilter], $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    operationLogs(fieldFilters: $fieldFilters, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      operationLogs {
        _id
        delta {
          field
          description
          old {
            value
            type
          }
          new {
            value
            type
          }
        }
        user {
          _id
          name
          login
        }
        created_at
      }
    }
  }
`
